import './style.scss'

export default {
  name: 'HeroImage',
  props: ['imageUrl'],
  props: {
    imageUrl: {
      type: String,
    },
  },
  render(h) {
    const { imageUrl, hasTeaser } = this
    return (
      <div class="HeroImage">
        <div
          class="HeroImage__img"
          style={`background-image: url('${imageUrl}')`}
        />
      </div>
    )
  },
}



// WEBPACK FOOTER //
// ./client/components/HeroImage/index.js